document.addEventListener("turbolinks:load", () => {
  form = $('.simple_form');
  var cocoon = window.form.find('.cocoon.channels');
  first_channel = cocoon.find('#youtube_master_setting_master_setting_channels_attributes_0_channel_id');

  first_channel.on("change", function(e) {
    autoSelectLanguage($(this));
  });
  cocoon.on('cocoon:after-insert', function(e, item) {
    item.find("[id$='channel_id']").on("change", function(e) {
      autoSelectLanguage($(this));
    });
    var selectedValue = document.querySelector('input[name="youtube_master_setting[kind]"]:checked').value;
    var titleField = item.find("[class$='master-setting-channel-title']");
    var descriptionField = item.find("[class$='master-setting-channel-description']");

    if (selectedValue === 'stream') {
      titleField.show();
      descriptionField.show();
    } else if (selectedValue === 'template') {
      titleField.hide();
      descriptionField.hide();
    }
  });

  autoSelectLanguage = function(channelSelect) {
    selected_channel = channelSelect.val();
    channel_info = channelSelect.data('language-codes').find(subarray => subarray[0] == selected_channel);
    if (channel_info) {
      language = channel_info[1][0];
      channelSelect.closest('.nested-fields').find("[id$='language_code']").val(language);
    }
  }
});
